module.exports = __webpack_public_path__ + "media/components/systemUpdate/improvingCH-40f1501115a5fbbf722a4c1f4a75a50a.png";